var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 491.208 491.208",
    style: {
      enableBackground: "new 0 0 491.208 491.208"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EAEAEA"
    },
    cx: 245.608,
    cy: 246.004,
    r: 160.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M359.208,132.404c62.4,62.4,62.4,164,0,227.2c-62.4,62.4-164,62.4-227.2,0"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C4C4C4"
    },
    cx: 245.608,
    cy: 246.004,
    r: 108
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.408,241.204c0,68.8-56,83.2-124.8,83.2s-124.8-14.4-124.8-83.2s56-72.8,124.8-72.8 S370.408,171.604,370.408,241.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAEA"
    },
    d: "M245.608,167.604c68.8,0,124.8,4,124.8,72.8s-56,83.2-124.8,83.2"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC114"
    },
    cx: 245.608,
    cy: 246.004,
    r: 53.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M283.208,208.404c20.8,20.8,20.8,54.4,0,75.2s-54.4,20.8-75.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3AC2F2"
    },
    d: "M491.208,111.604c0-44.8-24-81.6-52.8-81.6c-29.6,0-52.8,36-52.8,81.6c0,39.2,18.4,55.2,42.4,57.6 c-11.2,52.8-10.4,196.8-10.4,233.6c0,44.8-1.6,58.4,20.8,58.4s20.8-13.6,20.8-58.4c0-36.8,0.8-180.8-10.4-232.8 C472.808,166.804,491.208,151.604,491.208,111.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#009CC6"
    },
    d: "M438.408,461.204c22.4,0,20.8-13.6,20.8-58.4c0-36.8,0.8-180.8-10.4-232.8 c24-3.2,42.4-18.4,42.4-57.6c0-44.8-24-81.6-52.8-81.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M102.408,132.404c0.8-0.8,0.8-3.2,0.8-4.8v-1.6l0,0c0,0,0-4.8,0-8.8c0-15.2,0.8-83.2-13.6-83.2 s-13.6,68-13.6,83.2c0,4,0,8.8,0,8.8h-11.2c0,0,0-4.8,0-8.8c0-15.2,0.8-83.2-13.6-83.2c-14.4,0-13.6,68.8-13.6,83.2c0,4,0,8.8,0,8.8 h-10.4c0,0,0-4.8,0-8.8c0-14.4,0.8-83.2-13.6-83.2s-13.6,68-13.6,83.2c0,4,0,8.8,0,8.8l0,0c0,0,0,0.8,0,1.6c0,1.6,0,3.2,0.8,4.8 c5.6,24.8,20.8,35.2,40.8,37.6c-12,52-11.2,196-11.2,232.8c0,44.8-1.6,58.4,20.8,58.4s20.8-13.6,20.8-58.4 c0-36.8,1.6-180.8-10.4-232.8C81.608,167.604,96.808,157.204,102.408,132.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M103.208,126.004c0,0,0-4.8,0-8.8c0-15.2,0.8-83.2-13.6-83.2s-13.6,68-13.6,83.2c0,4,0,8.8,0,8.8 h-11.2c0,0,0.8-4.8,0.8-8.8c0-14.4,4-80-12-82.4v426.4c24,0,19.2-14.4,19.2-58.4c0-36.8,0.8-180.8-11.2-232.8 c19.2-2.4,35.2-12.8,40.8-37.6c0.8-0.8,0.8-3.2,0.8-4.8C103.208,126.804,103.208,126.004,103.208,126.004L103.208,126.004z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.aa04e0072130d58ff6f8487ff1b38876.svg";
export { ForwardRef as ReactComponent };